import { render, staticRenderFns } from "./addressTable.vue?vue&type=template&id=784e955f&scoped=true&"
import script from "./addressTable.vue?vue&type=script&lang=js&"
export * from "./addressTable.vue?vue&type=script&lang=js&"
import style0 from "./addressTable.vue?vue&type=style&index=0&id=784e955f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784e955f",
  null
  
)

export default component.exports